import React from "react";
import { Button } from "react-bootstrap";

export default function DeleteButton({ handler }) {
  return (
    <div>
      <Button onClick={handler} variant="danger" size="md" title="Delete" className="flex flex-col">
        <i className="fa fa-trash text-red-500" />
      </Button>
    </div>
  );
}
